import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from "react-cookie";
import TagManager from "react-gtm-module";
import Auth0ProviderWithHistory from "./auth0Provider";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import * as Sentry from "@sentry/react";
import NzPricingWalkthroughShell from "./dev/NzPricingWalkthroughShell";
import AdminLogsWalkthroughShell from "./dev/AdminLogsWalkthroughShell";

Sentry.init({
  dsn: "https://4f62364393c53bc729f6a3316e5b67b9@o4509880033673216.ingest.us.sentry.io/4509880340643840",
  sendDefaultPii: true
});

const tagManagerArgs = {
  gtmId: "GTM-5776VKJQ"
};

TagManager.initialize(tagManagerArgs);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

if (process.env.REACT_APP_NZ_PRICING_WALKTHROUGH === "1") {
  sessionStorage.setItem("selectedPortal", "Administrator");
  root.render(
    <React.StrictMode>
      <NzPricingWalkthroughShell />
    </React.StrictMode>
  );
} else if (process.env.REACT_APP_ADMIN_LOGS_WALKTHROUGH === "1") {
  sessionStorage.setItem("selectedPortal", "Administrator");
  root.render(
    <React.StrictMode>
      <AdminLogsWalkthroughShell />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <Auth0ProviderWithHistory>
          <Router>
            <CookiesProvider>
              <App />
              <ToastContainer />
            </CookiesProvider>
          </Router>
        </Auth0ProviderWithHistory>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}

reportWebVitals();
